module.exports = "/img/_/_/_/assets/images/creeper/battle/epic//5.jpg?9967fba65dd8935d7fed55291ccfc792";